'use client';

import { createWithEqualityFn } from 'zustand/traditional';
import { devtools } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { config } from '@/config';
import { Environment } from '@/types/enums/environment';

const applyDevtools = (config.nodeEnv === Environment.Production
    ? (fn: unknown) => fn
    : devtools) as unknown as typeof devtools;

export interface LocaleConfirmModalDetails {
    selectedLocale?: string;
    isLoggedIn: boolean;
}

export interface ModalsState {
    localeConfirm: {
        isOpen: boolean;
        details: LocaleConfirmModalDetails;
    };
}
export const useModalStore = createWithEqualityFn<{
    modals: ModalsState;
    updateModal: <K extends keyof ModalsState>(key: K, updatedModalState: ModalsState[K]) => void;
}>()(
    applyDevtools(
        (set) => ({
            modals: {
                localeConfirm: {
                    isOpen: false,
                    details: {
                        selectedLocale: 'en-INT',
                        isLoggedIn: false,
                    },
                },
            },
            updateModal: <K extends keyof ModalsState>(
                key: K,
                updatedModalState: ModalsState[K],
            ) => {
                set(
                    (state) => ({
                        ...state,
                        modals: {
                            ...state.modals,
                            [key]: updatedModalState,
                        },
                    }),
                    false,
                    'Setting of Modal',
                );
            },
        }),
        { name: `MPW ${config.theme} Modal Store` },
    ),
    shallow,
);
